import { Api } from 'api';
import { CRUDResponse } from 'api/interfaces/CRUDResponse';
import { Firm, FirmPayload } from 'api/interfaces/firm';
import { Dispatch } from 'redux';
import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { ApplicationState } from 'redux/applicationState';
import { FirmsActions } from 'redux/reducers/firmsReducer';

export const deleteFirm =
  (firm: Firm) =>
  (dispatch: Dispatch<Action<FirmsActions>>, _: () => ApplicationState, api: Api): VoidFunction => {
    dispatch(createAction(FirmsActions.deleteFirmStarted));
    const task = api.deleteFirm(FirmPayload.fromFirm(firm));

    task
      .run()
      .then((result: CRUDResponse): void => {
        if (result.success) {
          dispatch(createAction(FirmsActions.deleteFirmCompleted, firm));
        } else {
          dispatch(createAction(FirmsActions.deleteFirmFailed, result.message));
        }
      })
      .catch((error: Error): void => {
        dispatch(createAction(FirmsActions.deleteFirmFailed, error.message));
      });

    return (): void => {
      task.cancel();
    };
  };
